/**
 * Generated bundle index. Do not edit.
 */

export {ChessboardModule} from './public_api';

export {ChessboardComponent as ɵa} from './src/app/modules/chessboard/chessboard.component';